import React, { useEffect, useState } from "react";
import QRCode from 'qrcode';
import { loader } from "../../loader";
import { toast } from "react-toastify";
import { ENDPOINT } from "../../axios/apiConfig";
import { postData } from "../../axios/apiHelper";
import { Col, Button } from "react-bootstrap";
import { useSidebar } from "../CommonComponent/LoginLayout";
import { useNavigate, useLocation } from "react-router-dom";

const PromoPage = () => {
  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const navigate = useNavigate();
  const { state } = useLocation()
  const { eventIdContext } = useSidebar();
  const localStorageEvent = JSON.parse(localStorage.getItem("EventIdContext"));
  const [eventData, setEventData] = useState(
    eventIdContext ? eventIdContext : localStorageEvent
  );
  const [eventPromo, setEventPromo] = useState([]);

  useEffect(() => {
    getEventPromo();
  }, [])

  const getEventPromo = async () => {
    try {
      loader("show");
      const payload = { "event_id": eventData?.eventId };
      const response = await postData(`${ENDPOINT.GETEVENTPROMO}`, payload);
      setEventPromo(response?.data?.data || []);
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    } finally {
      loader("hide");
    }
  }

  const handleDownload = async () => {
    try {
      let fileName = (eventData?.eventTitle).replaceAll(" ", "_")
      const canvas = await QRCode.toCanvas(eventPromo?.link, { width: 300 });
      const pngUrl = canvas.toDataURL('image/png').replace(/^data:image\/[^;]/, 'data:application/octet-stream');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = `${fileName}_ChatLink.png`; // Set the filename
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  const copyToClipboard = async () => {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(eventPromo?.link);
      toast.success("content copied to the clipboard!");
    } else {
      unsecuredCopyToClipboard(eventPromo?.link);
    }
  }

  const unsecuredCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
      toast.success("content copied to the clipboard!");
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
    }
    document.body.removeChild(textArea);
  };

  const handlePreviewInNewTab = async (e) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(eventPromo?.link);
      window.open(eventPromo?.link, "_blank");
    } catch (error) {
      console.error("Error preview in new window:", error);
    }
  };

  return (
    <>
      <Col className="right-sidebar custom-change event-collection promo">
        <div className="custom-container">
          <div className="row">
            <div className="top-header regi-web sticky">
              <div className="page-title">
                <h3>Promo Webpage</h3>
              </div>
              {
                eventPromo?.length != 0 && (
                  <div className="top-right-action">
                    <div className="action-btn-add" style={{ margin: "0" }}>
                      <Button className="btn" onClick={handleDownload}>
                        Download QR code<img src={`${path_image}qr-code-icon.svg`} alt="" />
                      </Button>
                      <Button className="btn" onClick={copyToClipboard}>
                        Copy Link <img src={`${path_image}link-icon.png`} alt="" />
                      </Button>
                      <Button className="btn btn-filled" onClick={(e) => {
                          handlePreviewInNewTab(e);
                        }}>
                        View In New tab
                      </Button>
                    </div>
                  </div>
                )
              }
            </div>
            <div className="promo-webpage-content">
              {
                eventPromo?.length == 0 ?
                  <div className="promo-no-content">
                    <h4 className="mb-4">We'll contact you soon to gather the Promo Webpage details.</h4>
                    <h4>If we've already spoken please bear with us as we code it. We'll be as fast as we can.</h4>
                  </div>
                  :
                  <div className="promo-content-view">
                    <div className="promo-content-view-inset">
                      {eventPromo?.link ? (
                        <iframe
                          src={eventPromo.link}
                          width="100%"
                          height="auto"
                          title="Promo Page"
                          loading="lazy"
                          sandbox="allow-scripts allow-same-origin"
                        ></iframe>
                      ) : (
                        <p>No promo available.</p>
                      )}
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};
export default PromoPage;
